<template lang="pug">
    div#footer.footer
        div.columns.top-footer
            div.column.has-text-left.is-one-third
                p.underbox.has-text-weight-semibold Contact Us
                
                p.fas.fa-home
                    span {{contact_info.address}}
                br

                p.fas.fa-phone
                    span {{contact_info.phone}}
                br

                p.fa.fa-mobile
                    span {{contact_info.phone_2}}
                br

                p.fas.fa-envelope
                    a(:href="`mailto:${contact_info.email}`")
                        span {{contact_info.email}}
                br
                p.fas.fa-envelope
                    a(:href="`mailto:${contact_info.email_2}`")
                        span {{contact_info.email_2}}
                br
                br
                
                a(:href="contact_info.facebook_url", target="_blank")
                    i.fab.fa-facebook-f
                        span    facebook
                br
                a(:href="contact_info.twitter_url", target="_blank")
                    i.fab.fa-twitter
                        span    twitter
                br
            div.column.is-one-third
                p.underbox.has-text-left.has-text-weight-semibold Where to find us
                div.has-text-center
                    //- iframe(src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1572.9674800567925!2d23.704494899999993!3d37.9553046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a1bc5765f398c7%3A0x33a6cb0624e6fd!2sMantzagriotaki+89%2C+Kallithea+176+72!5e0!3m2!1sen!2sgr!4v1443878700602")
                    iframe(src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3145.309130503176!2d23.710286415669316!3d37.96991447972424!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a1bce3ac5ac9a7%3A0x92eab16541856!2zzpTOt868zr_Phs-Ozr3PhM6_z4IgNTksIM6RzrjOrs69zrEgMTE4IDUx!5e0!3m2!1sel!2sgr!4v1596704383954!5m2!1sel!2sgr")
        div.footer-separator
        div.columns.bottom-footer
            div.column.has-text-left
                p
                    span {{getCopyrightNotice()}}

</template>

<script>
export default {
    name: "MainFooter",
    data: function () {
        return {
            contact_info: {
                //address: " Mantzagriotaki 89, Kallithea, 17672",
                address: " Dimofontos 59, Ano Petralona, Athens, 11851",
                // phones: " 211 2163425, 6974530043",
                phone: " 211-4084711",
                phone_2: " 6974530043",
                email: " info@mindcore.gr",
                email_2: " mindcoregr@gmail.com",
                facebook_url: "https://www.facebook.com/MindCoreHellas/",
                twitter_url: "https://twitter.com/MindCoreGreece",
            }
        };
    },
    methods: {
        getCopyrightNotice: function () {
            let d = new Date()
            let year = d.getFullYear();
            return ("© " + year + " Copyright Mindcore. All rights reserved");
        }
    }
}
</script>

<style scoped>
i {
    color: rgb(74, 74, 74);
    vertical-align: middle;
}

p {
    margin-left: 2px;
    padding-bottom: 4px;
}

span {
    font-weight: 100;
    font-family:Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 16px;
}

.grey {
    color: rgb(90, 90, 90);
    padding-bottom: 0.75rem;
}

.footer-separator {
    border-bottom-color: rgb(111, 111, 111);
    border-bottom-style: solid;
    border-bottom-width: 1px;
    margin-bottom: 26px;
}

.underbox {
    border-bottom-style: solid;
    border-bottom-color: rgb(111, 111, 111);
    border-bottom-width: 1px;
    border-bottom-width: 80%;
    margin-bottom: 2rem;
}

.copyright-notice {
    font-family: Quicksand;
    margin-bottom: 19px;
}

.footer {
    padding-bottom: 2vh;
    background-color: #E8E8E8;
}
</style>
